<mat-toolbar class="header">
  <div class="header-inner">
    <a routerLink="/home" class="logo">Foodies</a>

    <nav class="nav">
      @if (auth.isLoggedIn()) {
        <a mat-button routerLink="/favorites">Обране</a>
        <a mat-button routerLink="/my-recipes">Мої рецепти</a>
        <a mat-button routerLink="/profile">Профіль</a>
        <button mat-button type="button" (click)="logout()">Вийти</button>
      } @else {
        <a mat-button routerLink="/login">Увійти</a>
        <a mat-button routerLink="/register">Реєстрація</a>
      }
    </nav>
  </div>
</mat-toolbar>
